/**
 * Delete Property Confirmation Dialog
 *
 * Confirmation dialog for deleting a property listing with cascade warning
 */

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';

interface IDeletePropertyDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
  propertyTitle: string;
}

export const DeletePropertyDialog = ({
  isOpen,
  onClose,
  onConfirm,
  isDeleting,
  propertyTitle,
}: IDeletePropertyDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Property?</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete{' '}
            <span className="font-semibold">{propertyTitle}</span>? This action cannot be undone.
          </DialogDescription>
        </DialogHeader>

        <div className="rounded-md bg-destructive/10 p-4 text-sm text-destructive">
          <p className="font-medium mb-1">Warning:</p>
          <ul className="list-disc list-inside space-y-1">
            <li>The property listing will be permanently deleted</li>
            <li>All generated videos will be deleted</li>
            <li>All video scenes and assets will be removed</li>
          </ul>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? 'Deleting...' : 'Delete Property'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
